import { makeAutoObservable } from 'mobx'
import { logger } from 'shared/lib'
import { SingletonRequest } from 'shared/api/lib'
import {
  type IResponseTenDlcVoiceIntegrity,
  type IResponseShakenStir,
  type IResponseVoiceIntegrity,
} from 'entities/Compliance/api/types/voiceServicesTypes'
import { VoiceServicesApi } from 'entities/Compliance/api/voiceServicesApi'
import { OrganizationCnam } from 'entities/Compliance/model/OrganizationCnam'
import { Phone } from 'entities/Phone/model/Phone'
import { OrganizationApi } from 'entities/Organization'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class ComplianceVoiceServicesStore {
  private _voiceIntegrity: IResponseVoiceIntegrity | null = null
  private _shakenStir: IResponseShakenStir | null = null
  private _cnam: OrganizationCnam | null = null
  private _origin: IResponseTenDlcVoiceIntegrity | null = null
  private _freeNumbers: Phone[] = []

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    this._cnam = new OrganizationCnam()
  }

  get origin() {
    return this._origin
  }

  get voiceIntegrity() {
    return this._voiceIntegrity
  }

  get statusVoiceIntegrity() {
    if (!this._voiceIntegrity) return

    return this._voiceIntegrity.status
  }

  get shakenStir() {
    return this._shakenStir
  }

  get statusShakenStir() {
    if (!this._shakenStir) return

    return this._shakenStir.status
  }

  get cnamServices() {
    return this._cnam
  }

  get freeNumbers() {
    return this._freeNumbers
  }

  loadFreeNumbers = async () => {
    const { data } = await OrganizationApi.getOrganizationCnamFreeNumbers()

    this._freeNumbers = data.map((number) => new Phone(number, this._entities))
  }

  setVoiceIntegrity = (data: IResponseVoiceIntegrity | null) => {
    this._voiceIntegrity = data
  }

  setShakenStir = (data: IResponseShakenStir | null) => {
    this._shakenStir = data
  }

  private _fetchComplianceVoiceServicesList = async () => {
    try {
      const { data } = await VoiceServicesApi.getComplianceVoiceServicesList()

      this._origin = data

      this.setVoiceIntegrity(data.voice_integrity_service)
      this.setShakenStir(data.shaken_stir_service)
      this.cnamServices?.syncData(data.cnam_services)
    } catch (e) {
      logger.error(e)
    }
  }

  fetchComplianceVoiceServicesList = new SingletonRequest(this._fetchComplianceVoiceServicesList)
    .request
}
